<template>
    <v-content>
        <!--         Step Header         -->
        <v-row
            style="font-size: 1em; font-weight: 400; color: #212121; letter-spacing: 1px;"
            no-gutters
        >
            <v-col
                class="mx-3 text-center"
            >
                Lets save your personalizations
            </v-col>
        </v-row>
        <v-row
            justify="center"
            style="font-size: 1.2em; font-weight: 600; color: #212121; letter-spacing: 1px;"
            no-gutters
        >
            <v-col
                class="mx-3 mt-2 mb-7 text-center"
            >
                Create Profile
            </v-col>
        </v-row>

        <!--            Input            -->
        <div
            class="bg5"
        >
            <v-row
                justify="center"
                no-gutters
            >
                <v-col
                    cols="12"
                    xs="12"
                    sm="10"
                    md="6"
                    lg="5"
                    xl="4"
                >
                    <v-row
                        justify="center"
                        class="my-4"
                        no-gutters
                    >
                        <v-text-field
                            v-model="email"
                            label="Email"
                            @keydown.enter="signUp"
                            prepend-inner-icon="email"
                            color="#32a852"
                            solo
                        />
                    </v-row>
                    <v-row
                        justify="center"
                        class="my-4"
                        no-gutters
                    >
                        <v-text-field
                            v-model="password1"
                            label="Password"
                            type="password"
                            @keydown.enter="signUp"
                            prepend-inner-icon="vpn_key"
                            color="#32a852"
                            solo
                        />
                    </v-row>
                    <v-row
                        justify="center"
                        class="my-4"
                        no-gutters
                    >
                        <v-text-field
                            v-model="password2"
                            label="Confirm Password"
                            type="password"
                            @keydown.enter="signUp"
                            prepend-inner-icon="vpn_key"
                            color="#32a852"
                            solo
                        />
                    </v-row>

        <!--          Navigation         -->
                    <v-row
                        no-gutters
                        class="mx-5"
                        justify="space-between"
                    >
                        <v-btn
                            class="btn2 mr-2"
                            @click="stepper = stepper - 1"
                            color = #74cf74
                        >
                        Back
                        </v-btn>
                        <v-btn
                            class="btn2 ml-2"
                            color = #74cf74
                            @click.prevent="signUp"
                            :disabled="disableStep4Next"
                        >
                        Create
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <v-row
                no-gutters
            >
                <v-col
                    class="text-right mt-1 pt-0 mx-5 red--text caption"
                >
                    <v-row
                        justify="center"
                        no-gutters
                    >
                        <v-col
                            class="text-right ma-0 pa-0"
                        >
                            {{errorMessage1}}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col
                            class="text-right ma-0 pa-0"
                        >
                            {{errorMessage2}}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col
                            class="text-right ma-0 pa-0"
                        >
                            {{errorMessage3}}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-content>
</template>


<script>
    import { Auth } from 'aws-amplify'

    export default {

        data: () => ({
            errorMessage1: null,
            errorMessage2: null,
            errorMessage3: null,
            email: null,
            password1: null,
            password2: null,
        }),

        methods: {
            next() {
                this.stepper = this.stepper + 1
            },

            signUp() {
                this.errorMessage1 = null;
                this.errorMessage2 = null;
                this.errorMessage3 = null;
                
                if (this.password1 != this.password2) {
                    this.errorMessage1 = "Passwords do not match"
                }
                
                if (this.password1.length < 6 | this.password2.length < 6) {
                    this.errorMessage2 = "Password must be at least 6 characters"
                }

                if (this.errorMessage1 == null && this.errorMessage2 == null) {
                    Auth.signUp({
                    username: this.email,
                    password: this.password1,
                    attributes: {
                        'email': this.email,
                        'custom:name': this.fname,
                        'custom:status': 'new',
                        'custom:role': 'subscriber'
                    }
                    }).then(() => {
                        this.$store.dispatch('data/storeCredentials',[this.email,this.password1]);
                        this.$store.dispatch('login/updateUsername',this.email);
                        this.$store.dispatch('data/createSQLAccount');
                        this.stepper = this.stepper + 1
                    
                    }).catch(error => {
                        console.log(error);
                        if(error.message == 'Invalid email address format.'){
                            this.errorMessage3 = 'Invalid email address'
                        } else {
                            this.errorMessage3 = error.message;
                        }
                    }); 
                }
            },

        },

        computed: {
            stepper: {
                get() {
                    return this.$store.getters['data/stepper'];
                },
                set(value) {
                    this.$store.dispatch('data/updateStepper',value);
                }
            },

            people(){
                return this.$store.getters['data/people'];
            },

            fname(){
                return this.people[0].name
            },

            disableStep4Next() {
                if(this.email == null | this.email == '' | this.password1 == null | this.password1 == '' | this.password2 == null | this.password2 == '') {
                    return true
                } else {
                    return false
                }
            },
            

        },
    }
</script>

<style scoped>
  .btn2 {
    font-family: "Noto Serif TC", serif;
    font-size: 0.9em;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }

  .btn3 {
    font-size: 0.9em;
    width: 100%;
    min-height: 48px;
    font-weight: 400;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: #74cf74 !important;
    font-weight: 600;
  }
</style>
